import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4","key":"svg-0"}]]

const IconCornerLeftDown = createReactComponent('outline', 'corner-left-down', 'CornerLeftDown', __iconNode);

export default IconCornerLeftDown;